import { ShieldAlert, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal, RevealStagger, RevealItem } from "@/components/shared/Reveal";

const PROHIBITED = [
  "Fraud & fake identities",
  "Falsified credentials",
  "Fake loads or listings",
  "Payment fraud",
  "Cargo theft schemes",
  "Unauthorized vehicle recovery",
  "Falsified insurance",
  "Other platform abuse",
];

export const AntiFraud = () => (
  <section id="report" data-testid="anti-fraud-section" className="py-24 md:py-32 bg-rr-navy relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-4xl mx-auto px-5 md:px-8 relative">
      <SectionHeading eyebrow="Platform Integrity" title="Protecting the RelayRigs Network" light testId="anti-fraud" />

      <Reveal delay={0.15}>
        <p className="mt-6 text-white/70 text-sm md:text-base max-w-2xl leading-relaxed">
          RelayRigs is built as a managed marketplace, not an anonymous classified board. The following are strictly prohibited across the network:
        </p>
      </Reveal>

      <RevealStagger className="mt-8 grid sm:grid-cols-2 gap-3">
        {PROHIBITED.map((p) => (
          <RevealItem key={p}>
            <div data-testid={`prohibited-item-${p.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-center gap-3 bg-white/[0.06] border border-white/10 rounded-lg px-4 py-3 text-sm font-semibold text-white/85">
              <ShieldAlert size={15} className="text-rr-orangeLight shrink-0" /> {p}
            </div>
          </RevealItem>
        ))}
      </RevealStagger>

      <Reveal delay={0.2}>
        <a
          href="/company#report"
          data-testid="report-fraud-cta"
          className="mt-9 inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-7 py-4 rounded-full hover:bg-white hover:text-rr-navy transition-all hover:-translate-y-1"
        >
          Report Fraud or a Safety Concern <ArrowRight size={18} />
        </a>
      </Reveal>
    </div>
  </section>
);
